/**
 * Dog Avenue: patch Media with text scroll reveal so rounded images skip img scale()
 * (avoids broken top corners). Loaded after sections.js; edit this file if sections.js is locked.
 */
import { animate as animate5, timeline as timeline7 } from "//dogavenue.co.uk/cdn/shop/t/58/assets/app.min.js?v=11786474696640468811782119877"
import { imageLoaded as imageLoaded2 } from "//dogavenue.co.uk/cdn/shop/t/58/assets/theme.js?v=37330413862334438961782119957"

customElements.whenDefined('media-with-text').then(() => {
	const Ctor = customElements.get('media-with-text')
	if (!Ctor || !Ctor.prototype) return

	Ctor.prototype.reveal = function (item) {
		const media = item.querySelector('.media-with-text__media')
		if (!media) return
		const skipImgScale =
			media.dataset && media.dataset.mwtSkipImgScale === 'true'
		const img = media.querySelector('img')
		const runMediaTimeline = () => {
			const steps = [[media, { opacity: [0, 1] }, { duration: 0.3 }]]
			const videoMedia = media.querySelector('video-media')
			if (!skipImgScale) {
				const animEl = media.querySelector('img, video-media')
				if (animEl) {
					steps.push([
						animEl,
						{ transform: ['scale(1.05)', 'scale(1)'] },
						{ duration: 0.3, at: '<' },
					])
				}
			} else if (videoMedia) {
				steps.push([
					videoMedia,
					{ transform: ['scale(1.05)', 'scale(1)'] },
					{ duration: 0.3, at: '<' },
				])
			}
			timeline7(steps)
		}
		if (img) {
			imageLoaded2(img).then(runMediaTimeline)
		} else {
			runMediaTimeline()
		}
		animate5(
			item.querySelector('.media-with-text__content > .prose'),
			{ opacity: [0, 1] },
			{ duration: 0.2, delay: 0.3 },
		)
	}
})
